export default __webpack_public_path__ + "static/media/ambience.611937fc.flac";